import { helper } from '@ember/component/helper';
import { isPresent } from '@ember/utils';

function isPresentFn([check]: any[] /*, hash*/) {
  return isPresent(check);
}
export default helper(isPresentFn);
